"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-color: rgb(255, 255, 255);
    .ecr-slider-wrapper {
        text-align: center;
        max-width: 1000px;
        li {
            list-style: none;
        }
        img {
            width: 100%;
        }
    }
`;
//# sourceMappingURL=StepsSliderStyled.js.map